module.exports = __webpack_public_path__ + "static/img/127_TO8_1677.86eded5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/127_TO8_1677.jpg
// module id = GgGy
// module chunks = 0